import React, { useEffect, useRef } from "react";

export default function SolarSizer() {
  const containerRef = useRef(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    // Initial buffer
    el.scrollTop = 2;

    const onScroll = () => {
      if (el.scrollTop < 2) {
        el.scrollTop = 2; // force away from top
      }
    };

    el.addEventListener("scroll", onScroll, { passive: true });

    return () => el.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        position: "fixed",
        inset: 0,
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
        overscrollBehavior: "contain",
        paddingTop: "2px",
      }}
    >
      <iframe
        src="https://solar-sizer-pro.onrender.com"
        style={{
          width: "100%",
          height: "100vh",
          border: "none",
          display: "block",
        }}
      />
    </div>
  );
}
